module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.d07108e7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-SemiBoldItalic.ttf
// module id = 363
// module chunks = 17